import React from 'react'

import { usePathname } from 'lib/next-intl'
import { useIsMobile } from 'store/server-context/device'
import cn from 'util/cn'
import currentPage from 'util/currentPage'

interface ILocationItemContainer extends React.HTMLAttributes<HTMLDivElement> {}
const LocationPickerItem = (props: ILocationItemContainer) => {
  const isMobile = useIsMobile()
  const pathname = usePathname()

  const { page, id } = currentPage(pathname)

  return (
    <div
      {...props}
      className={cn(
        'w-[380px] cursor-pointer',
        'focus:bg-background-2nd focus:outline-none',
        'hover:bg-background-2nd hover:outline-none',
        'active:bg-background-2nd active:outline-none',
        isMobile && [
          'w-full',
          page === 'spot-feed' &&
            !id && [
              'focus:bg-background_elevated_still-1st',
              'hover:bg-background_elevated_still-1st',
              'active:bg-background_elevated_still-1st'
            ]
        ]
      )}
    />
  )
}

export default LocationPickerItem
